
import React from 'react';
import { ChevronLeftIcon } from '../../Icons';

interface SelectionModeHeaderProps {
    selectedCount: number;
    totalCount: number;
    onCancel: () => void;
}

export const SelectionModeHeader: React.FC<SelectionModeHeaderProps> = ({ 
    selectedCount, 
    totalCount, 
    onCancel 
}) => {
    return (
        <div className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 shadow-md z-[110] px-4 py-4 animate-fade-in-down">
            <div className="max-w-[1700px] mx-auto flex justify-between items-center px-4 sm:px-6 lg:px-8">
                <div className="flex items-center space-x-4">
                    <button 
                        onClick={onCancel} 
                        className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                        aria-label="Volver"
                    >
                        <ChevronLeftIcon className="w-8 h-8 text-gray-600"/>
                    </button>
                    <div>
                        <h3 className="text-lg font-black text-gray-800 uppercase tracking-tighter">Modo de Selección Masiva</h3>
                        <p className="text-sm text-sky-600 font-bold">{selectedCount} de {totalCount} inmuebles seleccionados</p>
                    </div>
                </div>
                <button 
                    onClick={onCancel} 
                    className="px-8 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-xl text-sm font-black uppercase tracking-wider transition-colors shadow-lg active:scale-95"
                >
                    CANCELAR
                </button>
            </div>
        </div>
    );
};
